import React from "react";
import { Check, X, Minus, TrendingUp } from "lucide-react";
import "./MatchBreakdown.css";

function MatchBreakdown({ country, profile }) {
  // Logic to determine status
  const incomeMet = profile.monthly_income >= country.min_income_requirement;
  const isTechHub = ["DE", "EE", "SG", "AE", "US", "UK"].includes(country.code);
  const jobsAvailable = country.open_jobs?.length > 0;

  const metrics = [
    {
      label: "Income Threshold",
      status: incomeMet ? "pass" : "fail",
      value: incomeMet
        ? "Requirement Met"
        : `Need $${country.min_income_requirement}`,
    },
    {
      label: "Skill Demand",
      status: jobsAvailable ? "pass" : "neutral",
      value: jobsAvailable ? "High Demand" : "Moderate Demand",
    },
    {
      label: "Visa Velocity",
      status: country.processing_time_days <= 45 ? "pass" : "neutral",
      value: `${country.processing_time_days} Days`,
    },
    {
      label: "Tech Ecosystem",
      status: isTechHub ? "pass" : "neutral",
      value: isTechHub ? "Global Hub" : "Emerging",
    },
  ];

  return (
    <div className="match-breakdown">
      <h4>Match Analysis</h4>
      <div className="breakdown-grid">
        {metrics.map((m, i) => (
          <div key={i} className={`breakdown-item ${m.status}`}>
            <div className="icon-box">
              {m.status === "pass" && <Check size={14} />}
              {m.status === "fail" && <X size={14} />}
              {m.status === "neutral" && <Minus size={14} />}
            </div>
            <div className="meta">
              <span className="label">{m.label}</span>
              <span className="value">{m.value}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MatchBreakdown;
